import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IDataSourceDefinition } from '../../../../../../shared/interfaces/data-source/data-source-definitions/data-source-definition.interface';
import { IUIDataSourceItem } from '../../../../data-source-items/interfaces/ui-data-source-item';
import { IViewTileDefinition } from '../../../interfaces/view-tile-definition.interface';

@Component({
  standalone: false,
  selector: 'suvo-bi-view-tile-wrapper',
  templateUrl: './view-tile-wrapper.component.html',
  styleUrls: ['./view-tile-wrapper.component.scss'],
})
export class ViewTileWrapperComponent {
  @Input() viewTile: IViewTileDefinition;
  @Input() item: IUIDataSourceItem;
  @Input() form: FormGroup;
  @Input() definition: IDataSourceDefinition;
  @Input() editItemMode: boolean;
}
